const AboutUs = () => {
  return (
    <section id="aboutUsSection" className="container">
      <div className="row align-items-center">
        {/* Left Side: Image */}
        <div className="col-md-6 about-image">
          <img src="/static/aboutus.png" alt="About Us Illustration" />
        </div>
        {/* Right Side: Content */}
        <div className="col-md-6">
          <div className="about-heading">
            <h2>ABOUT US</h2>
          </div>
          <p>
            TELSA (Traceability Sawit) Super Apps adalah sebuah platform
            aplikasi yang memiliki fokus pada pengelolaan rantai pasok yang
            mencakup, pasokan TBS, transportasi, pemrosesan utama dan lebih
            lanjut hingga menghasilkan Crude Palm Oil (CPO) berbasis konsep
            Blockchain.
          </p>
          <div className="intro-section">
            <h5>
              <strong>Introduction</strong>
            </h5>
            <p>
              TELSA Super Apps dibuat karena keresahan masyarakat karena
              sulitnya mendata proses transfer komoditas kelapa sawit, dari hulu
              hingga hilir. Maka terciptalah TELSA sebagai solusi untuk
              membangun sistem ketelusuran produk kelapa sawit yang
              berkelanjutan serta untuk meningkatkan efektivitas proses transfer
              komoditas kelapa sawit yang dapat dikembangkan secara{" "}
              <strong>Real-Time</strong>.
            </p>
          </div>
          {/* Features */}
          <ul className="feature-list">
            <li>
              <i className="bi bi-check-circle-fill"></i> Visibilitas dalam
              transfer bahan pasokan
            </li>
            <li>
              <i className="bi bi-check-circle-fill"></i> Transparansi dalam
              hasil crude palm oil
            </li>
            <li>
              <i className="bi bi-check-circle-fill"></i> Traceability dalam
              menelusuri bahan baku TBS
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
